import { createSlice } from '@reduxjs/toolkit'

type Props = {
  boolean: boolean
  isPost: boolean
}

const initialState: Props = {
  boolean: false,
  isPost: false,
}

const dialogPhotoReducer = createSlice({
  name: 'dialogPhoto',
  initialState: initialState,
  reducers: {
    dialogPhotoState(state, action) {
      state.boolean = action.payload
    },
    postPhoto(state, action) {
      state.isPost = action.payload
    },
  },
})

export const { dialogPhotoState, postPhoto } = dialogPhotoReducer.actions

export default dialogPhotoReducer.reducer
